"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DotApiSite = void 0;
const tslib_1 = require("tslib");
/**
 * Get information from {@link https://dotcms.com/docs/latest/multi-site-management | DotCMS Sites}
 */
class DotApiSite {
    constructor(httpClient) {
        this.dotCMSHttpClient = httpClient;
    }
    getCurrentSite() {
        return this.dotCMSHttpClient
            .request({
            url: `/api/v1/site/currentSite`
        })
            .then((response) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (response.status === 200) {
                const data = yield response.json();
                const _a = data.entity, { map } = _a, site = tslib_1.__rest(_a, ["map"]);
                return site;
            }
            throw {
                message: yield response.text(),
                statusCode: response.status
            };
        }));
    }
}
exports.DotApiSite = DotApiSite;
